<template>
  <div class="pc-summary">
    <h3 class="pc-summary__title">Your Selections</h3>

    <div class="pc-summary__card">
      <!-- Payment method -->
      <div class="pc-summary__row">
        <DollarSVG class="pc-summary__icon" />
        <div>
          <div class="pc-summary__label">Payment method</div>
          <div class="pc-summary__value">
            {{ userSelectedOptionDetails.paymentMethod }}
          </div>
        </div>
      </div>

      <!-- Charge immediately -->
      <div
        class="pc-summary__row"
      >
        <FileSVG class="pc-summary__icon" />
        <div>
          <div class="pc-summary__label">Payment type</div>
          <div
            v-if="userSelectedOptionDetails.isChargeImmediately"
            class="pc-summary__value"
          >Charge Immediately</div>
          <div
            v-else
            class="pc-summary__value"
          >Scheduled Payments</div>
        </div>
      </div>


      <!-- Scheduled payments -->
      <div
        v-if="scheduledPayments.length"
        class="pc-summary__schedule"
      >
        <ul class="pc-summary__schedule-list">
          <li
            v-for="p in scheduledPayments"
            :key="p.date"
            class="pc-summary__schedule-item"
          >
            <span>{{ p.date }}</span>
            <span>${{ p.amount.toFixed(2) }}</span>
          </li>
        </ul>
      </div>

      <div class="pc-summary__divider"></div>

      <!-- Total -->
      <div class="pc-summary__total">
        <span>Total payments scheduled</span>
        <span class="pc-summary__total-amount">
          ${{ totalAmountForPay.toFixed(2) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DollarSVG from '@/assets/images/icons/dollar.svg'
import FileSVG from '@/assets/images/icons/file.svg'

export default {
  components: {
    FileSVG,
    DollarSVG,
  },
  props: {
    scheduledPayments: {
      type: Array,
      default: () => [],
    },
    userSelectedOptionDetails: {
      type: Object,
      required: true,
    },
    totalAmountForPay: {
      type: Number,
    },
  },
}
</script>
